
import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hey everyone! My name is{" "}
            <span className="purple">Matthew</span>, but you may know me
            as <span className="purple">Wilecurity</span>. I'm a
            Cybersecurity Engineer and technology entrepreneur passionate
            about understanding how systems fail, discovering
            vulnerabilities, and strengthening security through practical
            research and experimentation.
            <br />
            <br />
            My technical interests include{" "}
            <span className="purple">
              vulnerability research and exploit development
            </span>
            , penetration testing, security tool development, and
            security monitoring. I enjoy exploring security technologies,
            conducting hands-on experiments, and documenting what I learn
            through practical projects.
            <br />
            <br />
            Beyond cybersecurity, I'm a business owner and the Co-Founder
            and CTO of <span className="purple">Mapelead</span>, where I
            contribute to building technology solutions, developing
            technical initiatives, and creating opportunities for people
            to learn and grow in technology. I believe in turning
            technical knowledge into practical solutions that address
            real-world problems.
            <br />
            <br />
            Outside security research, I enjoy:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Building and experimenting with security tools
            </li>
            <li className="about-activity">
              <ImPointRight /> Exploring new technologies and technical labs
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing and sharing technical knowledge
            </li>
            <li className="about-activity">
              <ImPointRight /> Building technology initiatives and exploring new business ideas
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Understand the weakness. Learn the technique. Build better security."
          </p>

          <footer className="blockquote-footer">Wilecurity</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
